import axios from "axios";
import Config from "../common/Config";
import FieldState from "../common/FieldState";
import LoadFailureResult from "../common/LoadFailureResult";
import OrderFormStep from "../common/OrderFormStep";
import FormTitle from "../components/formTitle/FormTitle";
import InputTextField from "../components/textField/InputTextField";
import MuiRadio from "../components/radio/MuiRadio";
import "./forms.scss";
import Select from "react-select";
import Button from "../components/button/Button";
import SecondaryButton from "../components/button/SecondaryButton";
import { CreateNotification } from "../components/notification/Notification";
import SaveAsDraft from "../components/modal/SaveAsDraft";

export default class PatientInfo2 extends OrderFormStep {
  constructor(props) {
    super(props);

    this.state = {
      amputationLevels: [],
      kLevels: [],
      footDirections: [],
      shippingCarriers: [],
      shippingMethods: [],
      states: [],
      patientInfo1UOMs: [],
      contactMethods: [],
      isSubmit: false,
      formData: {},
      formState: {
        shippingAddress1: new FieldState(true),
        shippingAddress2: new FieldState(false),
        city: new FieldState(true),
        zip: new FieldState(true),
        shippingCarrierId: new FieldState(true),
        shippingCarrierName: new FieldState(false),
        shippingMethodId: new FieldState(true),
        shippingMethodName: new FieldState(false),
        stateId: new FieldState(true),
        stateName: new FieldState(false),
      },
    };

    this.handleFootSizeChange = this.handleFootSizeChange.bind(this);
  }

  componentDidMount() {
    // this.loadData();
    this.loadShippingData();
  }

  handleFootSizeChange(e, value) {
    let formState = this.state.formState;
    formState.footSize.value = value;
    this.setState({ formState: formState, hasDataChanged: true });
  }

  async loadShippingData() {
    await axios.get(Config.baseApiUrl + "shippingCarriers").then(
      (response) => {
        this.setState({ shippingCarriers: response.data });
      },
      (error) => {
        this.props.handleError(new LoadFailureResult());
      }
    );

    await axios.get(Config.baseApiUrl + "shippingMethods").then(
      (response) => {
        this.setState({ shippingMethods: response.data });
      },
      (error) => {
        this.props.handleError(new LoadFailureResult());
      }
    );
    await axios.get(Config.baseApiUrl + "states").then(
      (response) => {
        this.setState({
          states: response.data.map((item) => {
            return {
              label: item.stateName,
              value: item.id,
            };
          }),
        });
      },
      (error) => {
        this.props.handleError(new LoadFailureResult());
      }
    );

    await axios.get(Config.baseApiUrl + "contactMethods").then(
      (response) => {
        this.setState({ contactMethods: response.data });
      },
      (error) => {
        this.props.handleError(new LoadFailureResult());
      }
    );

    let config = {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
      },
    };
    const { data } = await axios.get(
      Config.baseApiUrl + "clinicinfos/" + this.props.formTypeId,
      config
    );

    this.setState({ formData: data });

    let formState = this.state.formState;

    formState.shippingAddress1.value = data["shippingAddress1"];
    formState.shippingAddress2.value = data["shippingAddress2"];
    formState.city.value = data["city"];
    formState.shippingCarrierId.value = data["shippingCarrierId"];
    formState.shippingMethodId.value = data["shippingMethodId"];
    formState.zip.value = data["zip"];
    formState.stateId.value = data["stateId"];
    formState.stateName.value = data["stateName"];

    this.setState({ formState: formState });

    this.setState({ isLoaded: true });
  }

  // async loadData() {
  //   try {
  //     this.setState({
  //       amputationLevels: (
  //         await axios.get(
  //           Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
  //           { params: { fieldName: "amputationLevel" } }
  //         )
  //       ).data,
  //       kLevels: (
  //         await axios.get(
  //           Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
  //           { params: { fieldName: "kLevel" } }
  //         )
  //       ).data,
  //       footDirections: (
  //         await axios.get(
  //           Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
  //           { params: { fieldName: "footDirection" } }
  //         )
  //       ).data,

  //       patientInfo1UOMs: (
  //         await axios.get(
  //           Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
  //           {
  //             params: { fieldName: "patientInfo1UOM" },
  //           }
  //         )
  //       ).data,
  //     });

  // let config = {
  //   headers: {
  //     Authorization:
  //       "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
  //   },
  //   params: {
  //     fieldNames: [
  //       "amputationLevel",
  //       "kLevel",
  //       "footDirection",
  //       "footSize",
  //       "patientInfo1UOM",
  //       "shippingCarrier",
  //     ],
  //   },
  // };

  // const { data } = await axios.get(
  //   Config.baseApiUrl + "fieldInput/" + this.props.formTypeId,
  //   config
  // );
  //     console.log(data, "data");
  //     let formState = this.state.formState;

  //     // formState.amputationLevel.value = data.find(
  //     //   (fi) => fi.fieldName === "amputationLevel"
  //     // ).fieldOptionId;
  //     // formState.kLevel.value = data.find(
  //     //   (fi) => fi.fieldName === "kLevel"
  //     // ).fieldOptionId;
  //     // formState.footDirection.value = data.find(
  //     //   (fi) => fi.fieldName === "footDirection"
  //     // ).fieldOptionId;
  //     // formState.patientInfo1UOM.value =
  //     //   data.fieldInputs.find((fi) => fi.fieldName === "patientInfo1UOM")
  //     //     .fieldOptionId ?? this.uomMetric;

  //     // let footSize = data.find((fi) => fi.fieldName === "footSize").numericData;
  //     // if (footSize !== null) {
  //     //   formState.footSize.value = footSize;
  //     // }

  //     // let height = data.fieldInputs.find(
  //     //   (fi) => fi.fieldName === "height"
  //     // ).numericData;
  //     // let weight = data.fieldInputs.find(
  //     //   (fi) => fi.fieldName === "weight"
  //     // ).numericData;

  //     // let isMetric = formState.patientInfo1UOM.value === this.uomMetric;
  //     // if (isMetric) {
  //     //   this.setCmState(height);
  //     //   this.setKgState(weight);
  //     // } else {
  //     //   this.setInchesState(height);
  //     //   this.setLbsState(weight);
  //     // }

  //     this.setState({ formState: formState });
  //   } catch (error) {
  //     // this.props.handleError(new LoadFailureResult());
  //   }

  //   this.setState({ isLoaded: true });
  // }

  saveData() {
    let config = {};

    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };

    for (let key in this.state.formState) {
      let fieldState = this.state.formState[key];
      this.state.formData[key] = fieldState.value;
    }
    if (this.state.formState.shippingMethodId.value)
      this.state.formData["shippingMethodName"] =
        this.state.shippingMethods.find(
          (item) => item.id === this.state.formState.shippingMethodId.value
        ).methodName;
    if (this.state.formState.shippingCarrierId.value)
      this.state.formData["shippingCarrierName"] =
        this.state.shippingCarriers.find(
          (item) => item.id === this.state.formState.shippingCarrierId.value
        ).carrierName;

    // return axios.post(
    //   Config.baseApiUrl + "clinicinfos/" + this.props.formTypeId,
    //   this.state.formData,
    //   config
    // );

    if (this.validateData().isValid) {
      return axios.post(
        Config.baseApiUrl + "clinicinfos/" + this.props.formTypeId,
        this.state.formData,
        config
      );
    } else {
      this.setState({
        isSubmit: true,
      });
      CreateNotification(this.validateData().errorMessage, "error");

      return null;
    }
  }
  saveShippingData() {
    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };

    let data = {};
    for (let key in this.state.formState) {
      let fieldState = this.state.formState[key];
      data[key] = fieldState.value;
    }

    // return axios.post(
    //   Config.baseApiUrl + "clinicInfos/" + this.props.formTypeId,
    //   data,
    //   config
    // );
  }

  handleError(id) {
    const { formState } = this.state;
    const errorClass =
      formState[id].isRequired &&
      (formState[id].value === "" ||
        formState[id].value === 0 ||
        formState[id].value === null);
    return errorClass ? true : false;
  }

  render() {
    if (!this.state.isLoaded) return this.makeLoadingText();

    return (
      <>
        <div className="checkFormWrapper filedWidth">
          <FormTitle
            title="Shipping Information"
            description="For your convenience, all WillowWood custom product order forms are listed below. "
          />

          <form className="checkform">
            <div className="fieldWrapper">
              <InputTextField
                label="Shipping Address line 1"
                variant="outlined"
                placeholder="43 Bay Meadows Ave.Wethersfield, CT "
                type="text"
                required={this.state.formState["shippingAddress1"].isRequired}
                value={this.state.formState.shippingAddress1.value}
                error={
                  this.handleError("shippingAddress1") && this.state.isSubmit
                }
                onChange={(e) => {
                  this.onInputChange(e, "shippingAddress1");
                }}
              />

              <InputTextField
                label="Shipping Address line 2"
                variant="outlined"
                placeholder="16 Euclid Street"
                type="text"
                required={this.state.formState["shippingAddress2"].isRequired}
                value={this.state.formState.shippingAddress2.value}
                error={
                  this.handleError("shippingAddress2") && this.state.isSubmit
                }
                onChange={(e) => this.onInputChange(e, "shippingAddress2")}
              />

              <InputTextField
                label="City"
                variant="outlined"
                placeholder="Some Text"
                type="text"
                required={this.state.formState["city"].isRequired}
                value={this.state.formState.city.value}
                error={this.handleError("city") && this.state.isSubmit}
                onChange={(e) => {
                  this.onInputChange(e, "city");
                }}
              />

              {/* <StateSelection /> */}
              <div className="customeState">
                <label>
                  State <span style={{ color: "red" }}>*</span>
                </label>
                <Select
                  options={this.state.states}
                  className="select"
                  styles={{
                    container: (baseStyles, state) => ({
                      ...baseStyles,
                      maxWidth: "384px",
                      width: "100%",
                    }),
                    control: (baseStyles) => ({
                      ...baseStyles,
                      width: "384px",
                      borderRadius: "6px",
                      border: "1px solid var(--neutral-100)",
                      minHeight: "unset",
                    }),
                    placeholder: (baseStyles) => ({
                      ...baseStyles,
                      color: "var(--neutral-200)",
                      fontFamily: "Display",
                      fontSize: "14px",
                      fontStyle: "normal",
                      fontWeight: "500",
                      lineHeight: "24px",
                    }),
                    singleValue: (baseStyles) => ({
                      ...baseStyles,
                      color: "var(--neutral-main)",
                      fontFamily: "Display",
                      fontSize: "14px",
                      fontStyle: "normal",
                      fontWeight: "500",
                      lineHeight: "24px",
                    }),
                    indicatorSeparator: (baseStyles) => ({
                      ...baseStyles,
                      display: "none",
                    }),

                    option: (baseStyles, { isFocused, isSelected }) => ({
                      ...baseStyles,
                      backgroundColor: isSelected
                        ? "#dddddd"
                        : isFocused
                        ? "#dddddd"
                        : "white",
                      color: "var(--neutral-main)",
                      cursor: "pointer",
                      fontFamily: "Display",
                      fontSize: "14px",
                      fontStyle: "normal",
                      fontWeight: "500",
                      lineHeight: "24px",
                    }),

                    menu: (baseStyles) => ({
                      ...baseStyles,
                      borderRadius: "6px",
                      border: "1px solid var(--neutral-100)",
                      boxShadow: "unset",
                    }),
                  }}
                  placeholder={this.state.formState.stateName.value}
                  defaultValue={{
                    label: this.state.formState.stateName.value,
                    value: this.state.formState.stateId.value,
                  }}
                  onChange={(e) => {
                    this.onSelect(e, "stateId");
                  }}
                />
              </div>

              <InputTextField
                label="Zip Code"
                variant="outlined"
                placeholder="Some Text"
                type="number"
                required={this.state.formState["zip"].isRequired}
                error={this.handleError("zip") && this.state.isSubmit}
                value={this.state.formState.zip.value}
                onChange={(e) => this.onInputChange(e, "zip")}
              />
            </div>
            <MuiRadio
              options={this.state.shippingCarriers}
              label="Carrier"
              required={this.state.formState["shippingCarrierId"].isRequired}
              error={
                this.handleError("shippingCarrierId") && this.state.isSubmit
              }
              defaultValue={parseInt(
                this.state.formState.shippingCarrierId.value
              )}
              onChange={(e) => {
                this.onRadioChange(e, "shippingCarrierId");
              }}
            />

            <MuiRadio
              options={this.state.shippingMethods}
              label="Shipping Method"
              required={this.state.formState["shippingMethodId"].isRequired}
              error={
                this.handleError("shippingMethodId") && this.state.isSubmit
              }
              defaultValue={this.state.formState.shippingMethodId.value}
              onChange={(e) => {
                this.onRadioChange(e, "shippingMethodId");
              }}
            />
          </form>
        </div>
        <div className="handelButtons">
          <SecondaryButton
            text="Save As Draft"
            onClick={this.props.handleClickOpen}
          />
          <div className="stepBtn">
            <SecondaryButton
              text="Back"
              onClick={() => this.props.handleBack(this.props.currentIndex - 1)}
              disabled={
                this.props.activeOuterStep === 0 && this.props.innerStep === 0
              }
            />
            <Button
              text="Next"
              disabled={this.state.isLoading}
              onClick={async () => {
                try {
                  this.setState({ isLoading: true });
                  const res = await this.saveData();
                  if (res.status === 204) {
                    this.props.handleNext(this.props.currentIndex);
                    this.setState({ isLoading: false });
                    CreateNotification("Submitted", "success");
                  }
                } catch (err) {
                  this.setState({ isLoading: false });
                }
              }}
            />
          </div>
        </div>
        <SaveAsDraft
          open={this.props.open}
          handleClose={this.props.handleClose}
          showSubmit={this.props.showSubmit}
          setShowSubmit={this.props.setShowSubmit}
        />
        {/* <h5 className="centeredText">Patient Information 2</h5>
        <Form className="centered">
          <Form.Group>
            <Form.Label>Amputation Level</Form.Label>
            {this.makeRadioButtonList({
              id: "amputationLevel",
              data: this.state.amputationLevels,
              valueField: "id",
              textField: "displayName",
            })}
          </Form.Group>
          <Form.Group>
            <Form.Label>K-Level</Form.Label>
            {this.makeRadioButtonList({
              id: "kLevel",
              data: this.state.kLevels,
              valueField: "id",
              textField: "displayName",
            })}
          </Form.Group>
          <Form.Group>
            <Form.Label>Leg</Form.Label>
            {this.makeRadioButtonList({
              id: "footDirection",
              data: this.state.footDirections,
              valueField: "id",
              textField: "displayName",
            })}
          </Form.Group>
          <Form.Group>
            <Form.Label>Foot Size: {this.getFootSize()}</Form.Label>
            <Grid container spacing={2}>
              <Grid item xs>
                <Slider
                  min={22}
                  max={31}
                  value={this.state.formState.footSize.value}
                  onChange={this.handleFootSizeChange}
                  valueLabelDisplay="auto"
                  aria-labelledby="continuous-slider-always"
                />
              </Grid>
              <Grid item>cm</Grid>
            </Grid>
          </Form.Group>
        </Form> */}
      </>
    );
  }

  getFootSize() {
    return this.state.formState.footSize.value + " cm";
  }
}
